var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 2.33398V0.583984H2.91667V2.33398H4.66667V3.50065H2.91667V5.25065H1.75V3.50065H0V2.33398H1.75ZM3.5 5.83398V4.08398H5.25V2.33398H9.33333L10.4008 3.50065H12.25C12.8917 3.50065 13.4167 4.02565 13.4167 4.66732V11.6673C13.4167 12.309 12.8917 12.834 12.25 12.834H2.91667C2.275 12.834 1.75 12.309 1.75 11.6673V5.83398H3.5ZM7.58333 11.084C9.19333 11.084 10.5 9.77732 10.5 8.16732C10.5 6.55732 9.19333 5.25065 7.58333 5.25065C5.97333 5.25065 4.66667 6.55732 4.66667 8.16732C4.66667 9.77732 5.97333 11.084 7.58333 11.084ZM5.71667 8.16732C5.71667 9.19982 6.55083 10.034 7.58333 10.034C8.61583 10.034 9.45 9.19982 9.45 8.16732C9.45 7.13482 8.61583 6.30065 7.58333 6.30065C6.55083 6.30065 5.71667 7.13482 5.71667 8.16732Z",
    fill: "#F28181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.9c6f4c2071613939a3d9328c24dfbce9.svg";
export { ForwardRef as ReactComponent };